import { render, staticRenderFns } from "./AccountRequirements.vue?vue&type=template&id=4e5686bf"
import script from "./AccountRequirements.vue?vue&type=script&lang=js"
export * from "./AccountRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports